<template>
  <v-form ref="form" v-model="valid" lazy-validation autocomplete="false">
    <v-row class="wrapperMask">
      <v-col cols="12" md="6" no-gutters class="paddingForm">
        <v-row no-gutters>
          <v-col
            cols="12"
            md="6"
            v-for="checkbox in subRolesList"
            :key="checkbox.id"
            class="py-0"
          >
            <v-checkbox
              class="margin-top-checkbox mb-md-4 mb-3"
              :label="checkbox.name"
              v-model="fromInformation.subRoles"
              :value="checkbox.id"
              :disabled="!isInfomation"
              hide-details="auto"
            ></v-checkbox>
          </v-col>
        </v-row>
        <label class="titleForm"><translate>First Name</translate></label>
        <v-text-field
          v-model="fromInformation.firstName"
          :rules="[emptyRules, maxRules]"
          outlined
          required
          :disabled="!isInfomation"
        ></v-text-field>
        <label class="titleForm"><translate>Last Name</translate></label>
        <v-text-field
          v-model="fromInformation.lastName"
          :rules="[emptyRules, maxRules]"
          outlined
          required
          :disabled="!isInfomation"
        ></v-text-field>

        <label class="titleForm">
          <translate>The languages you speak</translate>
        </label>
        <AutocompleteLimit v-model="langSelect" :items="countryLang" required />
      </v-col>
      <v-col cols="12" md="6" class="paddingForm pt-0">
        <label class="titleForm"><translate>Country</translate></label>
        <v-autocomplete
          v-model="countrySelect"
          :items="countryList"
          :placeholder="$gettext('Select country')"
          item-value="id"
          item-text="name"
          return-object
          outlined
          clearable
          :disabled="!isInfomation"
          @change="changeCountry"
        >
          <template v-slot:item="{ item }">
            <CountryFlag
              :icon="item.id.toLowerCase()"
              marginRight="margin-right-10"
            />
            {{ item.name }}
          </template>
          <template slot="no-data">
            <translate class="ml-3">No data available</translate>
          </template>
        </v-autocomplete>

        <label class="titleForm">
          <translate>State/Region/Province</translate>
        </label>
        <v-autocomplete
          v-model="stateSelect"
          :items="stateList"
          :placeholder="$gettext('Select state/region/province')"
          item-value="name"
          item-text="name"
          return-object
          outlined
          clearable
          @change="changeState"
          :disabled="!stateList.length"
        >
          <template v-slot:item="{ item }">
            <span class="capitalizeText">{{ item.name }}</span>
          </template>
          <template slot="no-data">
            <translate class="ml-3">No data available</translate>
          </template>
        </v-autocomplete>

        <label class="titleForm"><translate>City</translate></label>
        <v-autocomplete
          v-model="citySelect"
          :items="cityList"
          :placeholder="$gettext('Select city')"
          item-value="id"
          item-text="name"
          return-object
          outlined
          clearable
          :disabled="!cityList.length"
        >
          <template v-slot:item="{ item }">
            <span class="capitalizeText">{{ item.name }}</span>
          </template>
          <template slot="no-data">
            <translate class="ml-3">No data available</translate>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-alert v-if="messageError" dense text type="error">
      {{ messageError }}
    </v-alert>

    <v-btn
      large
      color="primary"
      @click="submit"
      class="font-weight-bold elevation-0 text-none subtitle-1"
    >
      <v-icon class="fas fa-paper-plane pr-3" size="18"></v-icon>
      <translate> Send</translate>
    </v-btn>
  </v-form>
</template>
<script>
import AutocompleteLimit from "@/components/Forms/AutocompleteLimit";
import CountryFlag from "@/components/CountryFlag";
import { mapState, mapGetters, mapActions } from "vuex";
import Vue from 'vue';
export default {
  name: "InfomationForm",
  components: { CountryFlag, AutocompleteLimit },
  data: () => ({
    messageError: "",
    valid: true,
    emptyRules: (v) => !!v || Vue.prototype.$gettext("Field is required"),
    maxRules: (v) => v.length <= 15 || Vue.prototype.$gettext("Field must be less than 15 characters"),
    countrySelect: {},
    langSelect: [],
    cityList: [],
    citySelect: {},
    stateSelect: null,
    stateList: [],
  }),
  computed: {
    ...mapState("location", {
      countryLang: "countryLang",
      countryList: "countryList",
      country: "country",
    }),
    ...mapState("stepper", {
      subRolesList: "subRolesList",
      isInfomation: "isInfomation",
      fromInformation: "fromInformation",
    }),
    ...mapGetters("stepper", {
      registerData: "registerData",
    }),
    token() {
      return this.$store.state.auth.token;
    },

  },
  watch: {
    // check set token => redirect profile
    token: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$router.push({ name: "profile" });
        }
      },
    },
  },
  methods: {
    ...mapActions({
      registerMember: "registerMember",
    }),
    async submit() {
      if (this.$refs.form.validate()) {
        let stateSelect = this.stateSelect || {};
        let citySelect = this.citySelect || {};
        
        const user = Object.assign({}, this.registerData)
        user.email = user.email.toLowerCase();
        user.country = this.countrySelect.id;
        user.state = stateSelect.name;
        user.city = citySelect.name;
        user.languages = this.langSelect.map((item) => item.id);
        user.feUrl = window.location.protocol + '//' + window.location.host;
        let message = await this.registerMember(user);
        if (message) {
          this.messageError = message;
        } else {
          this.$store.commit("location/SET_CURRENT_LOCATION", {
            country: this.countrySelect,
            region: "",
            city: this.citySelect.name,
            languages: this.langSelect,
          });
          this.$store.state.stepper.formRegistMember = {
            email: '',
            password: '',
          }
          this.$store.state.stepper.fromInformation = {
            firstName: '',
            lastName: '',
            city: '',
            phone: '',
            country: '',
            subRoles: [],
          }
        }
      }
    },
    async setStateList(id) {
      this.stateList = await this.$store.dispatch(
        "location/getStateLocation",
        id
      );
    },
    async setCityList(id) {
      this.cityList = await this.$store.dispatch(
        "location/getCityLocation",
        id
      );
    },
    async changeCountry(val) {
      if (val) {
        await this.setStateList(val.id);
      } else {
        this.stateList = [];
        this.cityList = [];
      }
    },
    async changeState(val) {
      if (val) {
        await this.setCityList(val.id);
      } else {
        this.cityList = [];
      }
    },
  },
};
</script>
